import { ALL_SHADE_HEADER_TITLE, ALL_SIZE_HEADER_TITLE } from 'shared/constants/productPage';


export const getHeaderText = (isSize: boolean) => {
  if (isSize) {
    return ALL_SIZE_HEADER_TITLE;
  }
  return ALL_SHADE_HEADER_TITLE;
};

